const module = {
  config: {
    name: "employee",
    icon: "group-2",
    desc: "Data Pengaturan Karyawan pada Aplikasi",
    layout: true,
    order: 5
  },
  routes: [
    // employees
    {
      name: 'employees',
      icon: 'group-2',
      path: `/employees`,
      translate_key: 'employees',
      component: () => import("./employees/employees.vue"),
      separator: ""
    },
    // field-facilitators
    {
      name: 'field-facilitators',
      icon: 'briefcase-2',
      path: '/field-facilitators',
      translate_key: 'field-facilitators',
      component: () => import('./field-facilitators/field-facilitators.vue'),
      separator: ''
    },
  ]
};
export default module;



// WEBPACK FOOTER //
// ./src/modules/employees/_index.js